(function() {
  'use strict';

  angular.module('blocks.notify', ['unsavedChanges']);
})();
